import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getSearchHistory(args = {}) {
    const { organizationId } = args
    if (!organizationId) return

    return HTTP.get(`/api/v1/organizations/${organizationId}/explore-history`)
  },

  saveSearchHistory(args = {}) {
    const { organizationId, term } = args

    return HTTP.post(
      `/api/v1/organizations/${organizationId}/explore-history`,
      { term }
    )
  },

  deleteSearchHistoryItem(args = {}) {
    const { organizationId, historyId } = args

    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/explore-history/${historyId}`
    )
  },

  deleteAllSearchHistory(args = {}) {
    const { organizationId, ids } = args

    return HTTP.post(
      `/api/v1/organizations/${organizationId}/explore-history/bulkOperation`,
      { operation: 'delete', ids }
    )
  },

  getContent(args = {}) {
    const {
      organizationId,
      limit = 10,
      from = 0,
      terms,
      sort,
      filters,
      projections,
      expansions,
      includeMatchingFields,
    } = args

    const params = {
      params: {
        from,
        limit,
        terms,
        sort,
        filters,
        projections,
        expansions,
        includeMatchingFields,
      },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(`/api/v1.1/stream/${organizationId}/explore`, params)
  },
}
